// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__1AcJt","spinner-wrapper":"spinner_spinner-wrapper__2UNe0","spinner-login":"spinner_spinner-login__V13AL"};